import * as React from 'react';
import { ReactElement, useEffect, useState } from 'react';
import { getBackOrderComments } from 'api/backorder';
import { BackOrderCommentResponse } from 'types/api/backorder';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';
import {
  commentHistoryTableColumns,
  commentHistoryTableHeader,
} from 'components/backorder/table/commentHistory/commentHistoryTableData';

interface Props {
  groupId: string;
}
const BackOrderCommentList = ({ groupId }: Props): ReactElement => {
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(1);
  const [backOrderComments, setBackOrderComments] = useState<BackOrderCommentResponse | null>(null);

  const getBackOrderCommentsData = async (pageIndex: number): Promise<void> => {
    const res = await getBackOrderComments({ groupId, pageNo: pageIndex });
    setBackOrderComments(res);
  };

  const onChangePage = async (pageIndex: number): Promise<void> => {
    setCurrentPageIndex(pageIndex);
    await getBackOrderCommentsData(pageIndex);
  };

  useEffect(() => {
    getBackOrderCommentsData(1).then();
  }, []);

  return (
    <DataTableLayout
      showPagination
      tableTitle={`Comment History(${backOrderComments?.totalItems ?? '-'})`}
      totalPages={backOrderComments?.totalPages ?? 0}
      onChangePage={onChangePage}
      currentPageIndex={currentPageIndex}
    >
      <DataTableHeader header={commentHistoryTableHeader} />
      <NewDataTableBody
        dataList={backOrderComments?.items ?? []}
        columns={commentHistoryTableColumns}
      />
    </DataTableLayout>
  );
};

export default BackOrderCommentList;
